import { Link } from 'react-router-dom';
import { trackEvent } from '../../lib/analytics';

const practiceAreas = [
    {
        id: "01",
        slug: "bancario",
        title: "Consultoria Estratégica em Produtos Bancários",
        description: "Crédito Consignado, Home Equity e operações Middle Market.",
        image: "https://images.unsplash.com/photo-1501167786227-4cba60f6d58f?auto=format&fit=crop&q=80",
        handlers: "Produtos Bancários"
    },
    {
        id: "02",
        slug: "civel",
        title: "Contencioso Cível Massificado",
        description: "CDC, Crédito Consignado e Middle Market, demandas ativas e contrárias.",
        image: "https://images.unsplash.com/photo-1505664194779-8beaceb93744?auto=format&fit=crop&q=80",
        handlers: "Contencioso Massificado"
    },
    {
        id: "03",
        slug: "civel-estrategico",
        title: "Contencioso Cível Estratégico",
        description: "Casos de alta complexidade do âmbito cível.",
        image: "https://images.unsplash.com/photo-1436450412740-6b988f486c6b?auto=format&fit=crop&q=80",
        handlers: "Litígio Estratégico"
    },
    {
        id: "04",
        slug: "imobiliario",
        title: "Regularização Imobiliária",
        description: "Usucapião Extrajudicial e Judicial, Inventário ou divórcio com partilha de bens.",
        image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80",
        handlers: "Regularização Imobiliária"
    },
    {
        id: "05",
        slug: "operacoes-imobiliarias",
        title: "Operações Imobiliárias",
        description: "Compra e venda e doação.",
        image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&q=80",
        handlers: "Operações Imobiliárias"
    },
];

export const LandingServices = () => {

    return (
        <section id="services" className="py-32 bg-white border-y border-stone-100 dark:border-white/5 font-sans">
            <div className="max-w-7xl mx-auto px-6">
                <div className="mb-24">
                    <div className="space-y-4">
                        <span className="text-pacces-gold font-bold text-[12px] uppercase tracking-[0.4em] block">Expertise Jurídica</span>
                        <h2 className="text-4xl md:text-6xl font-serif text-pacces-ebony leading-[0.9] tracking-tighter">
                            Áreas de Atuação
                        </h2>
                    </div>
                </div>

                <div className="divide-y divide-stone-200">
                    {practiceAreas.map((area) => (
                        <div key={area.id} className="group py-12 grid md:grid-cols-12 gap-8 items-center hover:bg-white/50 transition-all duration-500 px-6 -mx-6 rounded-sm">
                            {/* Número */}
                            <div className="md:col-span-1 text-2xl font-serif text-pacces-gold/20 group-hover:text-pacces-gold transition-colors duration-500 font-light">
                                {area.id}
                            </div>

                            {/* Info */}
                            <div className="md:col-span-3 flex items-center gap-6">
                                <div className="relative w-32 h-32 overflow-hidden rounded-sm border border-stone-100 group-hover:border-pacces-gold/30 transition-colors duration-500">
                                    <img
                                        alt={area.title}
                                        className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-110 group-hover:scale-100"
                                        src={area.image}
                                        loading="lazy"
                                    />
                                </div>
                            </div>

                            {/* Título e Descrição */}
                            <div className="md:col-span-5 lg:col-span-5">
                                <h3 className="text-2xl font-serif mb-2 text-pacces-ebony group-hover:text-pacces-gold transition-colors duration-500">
                                    {area.title}
                                </h3>
                                <p className="text-base text-stone-500 font-light leading-relaxed max-w-lg">
                                    {area.description}
                                </p>
                            </div>

                            {/* CTA */}
                            <div className="md:col-span-3 lg:col-span-3 lg:text-right">
                                <Link
                                    to={`/areas/${area.slug}`}
                                    onClick={() => trackEvent('view_service_detail', { service: area.slug })}
                                    className="inline-flex items-center gap-4 bg-pacces-ebony text-pacces-ivory px-10 py-4 text-[12px] font-bold rounded-none uppercase tracking-[0.3em] transition-all duration-300 ease-in-out 
                                               hover:bg-pacces-gold hover:text-pacces-ebony hover:translate-y-[-2px] hover:shadow-xl group-active:scale-[0.98]"
                                >
                                    Saiba Mais
                                    <span className="material-symbols-outlined text-[14px]">arrow_forward</span>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
